


































































import Vue from 'vue';
import {Component} from "vue-property-decorator";
import AsiPageTitle from "@/components/common/AsiPageTitle.vue";
import {Icon} from "@/helpers/icons";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import AsiToolbar from "@/components/common/AsiToolbar.vue";
import AsiCard from "@/components/common/AsiCard.vue";
import AsiBtn from "@/components/common/AsiBtn.vue";
import AsiAutocomplete from "@/components/common/AsiAutocomplete";
import {EmploymentType, Gender, ReportState} from "@/helpers/constants";
import {enumToSelectItems} from "@/helpers/functions_asi";
import ExportModel from '@/models/export/Export';
import AsiCountryAutocompleteInput from "@/components/common/AsiCountryAutocompleteInput.vue";
import AsiTextField from "@/components/common/AsiTextField";
import AsiDatePicker from "@/components/common/AsiDatePicker.vue";
import OrderAutocompleteInput from "@/components/order/OrderAutocompleteInput.vue";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import AsiCheckbox from "@/components/common/AsiCheckbox";

@Component({
	components: {
		AsiCheckbox,
		OrderAutocompleteInput, AsiDatePicker, AsiTextField, AsiCountryAutocompleteInput,
		AsiAutocomplete, AsiBtn, AsiCard, AsiToolbar, AsiContentContainer, AsiPageTitle
	}
})
export default class Export extends Vue {

	private icons = Icon;
	private loading: boolean = false;
	private model: ExportModel = new ExportModel();

	private genderOptions = enumToSelectItems(Gender, true);
	private employmentTypeOptions = enumToSelectItems(EmploymentType, true);
	private reportStateOptions = enumToSelectItems(ReportState, true);

	private get dateRange(): string[] | null {
		const ret = [];
		if (this.model.dateFrom !== null) ret.push(this.model.dateFrom);
		if (this.model.dateTo !== null) ret.push(this.model.dateTo);
		return ret;
	}

	private set dateRange(value: string[] | null) {
		this.model.dateFrom = value === null ? null : (value[0] ?? null);
		this.model.dateTo = value === null ? null : (value[1] ?? null);
	}

	private get amountRangeFrom(): number | null {
		let ret = null;
		if (this.model.amountFrom !== null) ret = this.model.amountFrom;
		return ret;
	}

	private set amountRangeFrom(value: number | null) {
		this.model.amountFrom = value === null ? null : (value ?? null);
	}

	private get amountRangeTo(): number | null {
		let ret = null;
		if (this.model.amountTo !== null) ret = this.model.amountTo;
		return ret;
	}

	private set amountRangeTo(value: number | null) {
		this.model.amountTo = !value ? null : (value ?? null);
	}

	private changeAmountRange() {
		if (this.model.amountFrom && this.model.amountTo && +this.model.amountFrom > +this.model.amountTo) {
			this.model.amountFrom = this.model.amountTo;
		}
	}

	private performExport(): void {
		this.loading = true;

		this.$exportService.export(this.model)
			.then(res => {
				const fileURL = window.URL.createObjectURL(new Blob([res.data]));
				const fileLink = document.createElement('a');
				const contentDisposition = res.headers['content-disposition'].split(';').map((x: string) => x.trim());

				const filename = contentDisposition.find((dispositionEntry: string) => {
					const dispositionEntrySplit = dispositionEntry.trim().split('=');
					if (dispositionEntrySplit.length > 1) {
						if ('filename' === dispositionEntrySplit[0]) {
							return true;
						}
					}
				}).split('=')[1];
				fileLink.href = fileURL;
				fileLink.setAttribute('download', filename);
				document.body.appendChild(fileLink);
				fileLink.click();
				fileLink.remove();
			})
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.exportError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => this.loading = false);
	}

}
